import {noop} from 'lodash';
import React, {FC, useCallback} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {InfoBubblePillVariantsEnum} from '../../../../../libs/shared/ui/src/components/tip/infoBubblePill';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {InboxesFiltersEnum} from '../../../../models/url/models/inboxesUrlModel';
import {
  InboxesParameters,
  isInboxesConversationsParameters,
} from '../../../../store/panels/inboxes/parameters/inboxesParameters';
import {clearInboxesParametersSelection} from '../../../../store/panels/inboxes/parameters/inboxesParametersHelpers';
import {buildParametersPath} from '../../../../store/panels/inboxes/parameters/inboxesParametersPathHelpers';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

interface AssignTabEducationTipProps extends SandboxEducationTipProps {
  parameters: InboxesParameters;
  onFilterClick: () => void;
}

/*
 * Component.
 */

export const AssignTabEducationTip: FC<AssignTabEducationTipProps> = (props) => {
  const {parameters, anchor, isVisible, onFilterClick} = props;

  const dispatch = useAppDispatch();

  const onNavigateToAssignedTab = useCallback(() => {
    if (!isInboxesConversationsParameters(parameters)) {
      return;
    }

    // Dismiss the education tip.
    onFilterClick();

    dispatch(
      navigateToLinkAction(
        buildParametersPath({
          ...clearInboxesParametersSelection(parameters),
          filters: [InboxesFiltersEnum.ASSIGNED],
          refinement: undefined,
        }),
      ),
    );
  }, [dispatch, parameters, onFilterClick]);

  return (
    <EducationTip
      anchor={anchor}
      position="bottom"
      isVisible={isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={
        <Trans id="infobubble-onboarding-assign-tab-title-showcase-growth">
          Next, click on the &ldquo;Assigned&rdquo; tab
        </Trans>
      }
      stepCounter={generateStepText(1, 4)}
      dataObjectName={OnboardingDataEventObject.DEMO_ASSIGN}
      primaryActionLabel={<Trans id="infobubble-onboarding-assign-tab-primary-action-label">Next</Trans>}
      onPrimaryClick={onNavigateToAssignedTab}
    >
      {
        <Trans id="infobubble-onboarding-assign-tab-description-showcase-growth">
          Another customer request just came in, and got automatically assigned to your teammate Brandon.
          Nice!
        </Trans>
      }
    </EducationTip>
  );
};
